module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.tickets,
      "label": "Listado de tickets disponibles",
      "placeholder": "Realiza la busqueda por la desripción",
      "dense": "dense",
      "item-value": "numero",
      "item-text": "numero",
      "return-object": "return-object",
      "solo": "solo",
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.seleccionarTicket
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('div', _vm._b({
          staticClass: "d-flex"
        }, 'div', data.attrs, false), [_c('span', {
          staticClass: "font-weight-700 success--text"
        }, [_vm._v(_vm._s(("#" + (data.item.numero))) + ",")]), _c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v("  " + _vm._s(data.item.razonSocial) + "  ")]), (data.item.serie) ? _c('span', {
          staticClass: "grey--text font-size-11"
        }, [_vm._v("-   " + _vm._s(data.item.serie) + "  ")]) : _vm._e()])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-card', {
          staticClass: "elevation-0",
          attrs: {
            "width": "520"
          }
        }, [_c('ticket-summary-info', {
          key: data.item.numero,
          staticClass: "animated fadeInUp faster",
          attrs: {
            "ticket": data.item,
            "handler": true
          },
          on: {
            "href": function () {}
          }
        })], 1)]
      }
    }]),
    model: {
      value: (_vm.numeroTicket),
      callback: function($$v) {
        _vm.numeroTicket = $$v
      },
      expression: "numeroTicket"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76ec8a99","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_listado_tickets_seleccionar.vue
// module id = 513
// module chunks = 1